import { Text } from 'common-components'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import NotFoundImage from 'assets/svgr-icons/AI_LIB_NOT_FOUND.svg'

export const NotFound: React.FC = () => {
  return (
    <Styled.NotFoundContainer>
      <NotFoundImage />
      <Styled.TextContent>
        <Text type="h1" color="secondarySemiDark">
          {translate(T.NO_RESULTS_FOUND_LABEL)}
        </Text>
        <Text type="h2" color="secondary">
          {translate(T.NO_RESULTS_FOUND_DESCRIPTION_LABEL)}
        </Text>
      </Styled.TextContent>
    </Styled.NotFoundContainer>
  )
}
